// @flow
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';

// Chip/pill lavanda con texto e icono en el azul de marca (primary).
// Fondo: tinte pálido de primary (#3c44d7) — el tema no tiene un primary más
// claro que primaryLL (#dce1f5), que resulta demasiado saturado frente al
// mockup, así que se usa rgba para conseguir el lavanda casi blanco.
// Esquinas redondeadas (8px) para el aspecto de "pill suave" del diseño.
// Móvil: a todo el ancho, debajo de la barra. Escritorio: ancho automático.
export const GoogleSourceLink: any = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 18px;
  border-radius: 8px;
  margin-bottom: 24px;
  background-color: rgba(60, 68, 215, 0.08);
  font-weight: 600;
  ${getFont(-1, 'compact')}
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: ${({ theme }) => theme.colors.primary};
  white-space: nowrap;
  transition: background-color 0.15s ease;

  svg {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    margin-right: 9px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryLL};
  }

  ${minMediaQueries.tablet`
    width: auto;
    margin-bottom: 0;
  `}
`;
